import { Directive, ElementRef, input, Renderer2 } from '@angular/core';
import { ParametrosService } from '../services/parametros.service';

@Directive({
  selector: '[appFeatureEnabled]',
})
export class AppFeatureEnabled {

  appFeatureEnabled = input.required<string[]>();
  constructor(private el: ElementRef, private renderer: Renderer2, private parametrosService: ParametrosService) { }

  ngOnInit() {
    // Replace this with your real group check logic
    this.parametrosService.checkAccess(this.appFeatureEnabled()).then(hasAccess => {
      if (!hasAccess) {
        this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
      }
    });
  }


}
